<!DOCTYPE html>
<html lang="en">

<head>
  <!-- Required meta tags -->
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
  <title>Reset Password</title>
  <!-- plugins:css -->
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css">

</head>

<body>
  <div class="container-scroller">
    <div class="container-fluid page-body-wrapper full-page-wrapper">
      <div class="content-wrapper d-flex align-items-center auth px-0">
        <div class="row w-100 mx-0">
          <div class="col-lg-4 mx-auto">
            <div class="auth-form-light text-left py-5 px-4 px-sm-5">
              <div class="brand-logo" style="text-align: center;">
                <img src="assets/images.png" alt="logo">
              </div>
              <form [formGroup]="form" (ngSubmit)="onSubmit()">

                <div class="form-group">
                  <label class="form-label">Password</label>
                  <div class="input-group">
                    <input [type]="passwordHidden ? 'password' : 'text'" formControlName="password" class="form-control"
                      [ngClass]="{ 'is-invalid': submitted && form.controls.password.invalid }" />
                    <div class="input-group-append">
                      <span class="input-group-text" (click)="togglePasswordVisibility()">
                        <i class="fas" [ngClass]="{'fa-eye-slash': passwordHidden, 'fa-eye': !passwordHidden}"></i>
                      </span>
                    </div>
                  </div>
                  <div *ngIf="submitted && form.controls.password.invalid" class="invalid-feedback">
                    <div *ngIf="form.controls.password.errors?.required">Password is required</div>
                    <div *ngIf="form.controls.password.errors?.minlength">Password must be at least 8 characters</div>
                  </div>
                </div>
                
                <div class="form-group">
                  <label>Confirm Password</label>
                  <div class="input-group">
                    <input [type]="confirmPasswordHidden ? 'password' : 'text'" formControlName="pwd" class="form-control"
                      [ngClass]="{ 'is-invalid': submitted && form.controls.pwd.invalid }" />
                    <div class="input-group-append">
                      <span class="input-group-text" (click)="toggleConfirmPasswordVisibility()">
                        <i class="fas" [ngClass]="{'fa-eye-slash': confirmPasswordHidden, 'fa-eye': !confirmPasswordHidden}"></i>
                      </span>
                    </div>
                  </div>
                  <div *ngIf="submitted && form.controls.pwd.invalid" class="invalid-feedback">
                    <div *ngIf="form.controls.pwd.errors?.required">Confirm Password is required</div>
                    <div *ngIf="form.controls.pwd.errors?.mustMatch">Passwords must match</div>
                  </div>
                </div>
            
              

                
                <div class="mt-3">
                  <button type="submit" class="btn btn-primary" [disabled]="!form.valid"><i class="fa fa-database"></i> Submit</button>

                </div>
                
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- content-wrapper ends -->
    </div>
    <!-- page-body-wrapper ends -->
  </div>
  <!-- container-scroller -->
  <!-- plugins:js -->

  <!-- endinject -->
</body>

</html>